<template>
  <b-modal
    centered
    hide-footer
    hide-header
    :size="size"
    :id="priority"
    no-close-on-esc
    :visible="visible"
    no-close-on-backdrop
    body-class="pl-0 pr-0"
  >
    <div class="close-button" v-if="closable" @click="$emit('on-close')">
      <aha-icon
        name="close"
        height="20"
        width="20"
        viewBox="0 0 24 24"
        class="cursor-pointer text-base-70 hover:text-primary-90"
      />
    </div>

    <slot name="title" />

    <div class="pr-3 pl-3 content-over">
      <div class="pt-3 pb-3 content-body">
        <slot name="body" />
      </div>

      <div :class="footerClass">
        <slot name="footer" />
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    priority: {
      type: String,
      default: 'low',
    },
    footerClass: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'md',
    },
    closable: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    // Prevent deselect
    setTimeout(() => {
      const modal = document.getElementById(this.priority)
      if (modal) {
        modal.addEventListener('mouseup', (e) => {
          e.stopPropagation()
        }, true)
      }
    }, 0)
  },
}
</script>

<style lang="scss" scoped>
.close-button {
  position: absolute;
  right: 16px;
  top: 12px;
  font-size: 20px;
  cursor: pointer;
}
.content-over {
  overflow: auto;
  max-height: 600px;
}
</style>
